//! moment.js locale configuration
//! locale : Kalaallisut [kl]

; (function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined'
        && typeof require === 'function' ? factory(require('moment')) :
    typeof define === 'function' && define.amd ? define(['moment'], factory) :
    factory(global.moment)
}(this, function (moment) {
    'use strict';
    
    var kl = moment.locale('kl', {
        months: 'januaari_februaari_marsi_apriili_maaji_juuni_juuli_aggusti_septembari_oktobari_novembari_decembari'.split('_'),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'sapaat_ataasinngorneq_marlunngorneq_pingasunngorneq_sisamanngorneq_tallimanngorneq_arfininngorneq'.split('_'),
        weekdaysShort: 'sap_at_marl_ping_sis_tall_arf'.split('_')
    });

    return kl;

}));



//////////////////
// WEBPACK FOOTER
// ./Content/scripts/moment/locale/kl.js
// module id = 163
// module chunks = 4